import { motion } from 'framer-motion';
import { ArrowUpRight, ChevronDown } from 'lucide-react';
import { LOANS, INSURANCE, preselectProduct } from '../data';

const NAV = [
    { label: 'Partners', href: '#partners' },
    { label: 'Process', href: '#process' },
    { label: 'Calculator', href: '#calculator' },
];

const DropItem = ({ href, title, value, testId }) => (
    <a
        href={href}
        data-testid={testId}
        onClick={() => value && preselectProduct(value)}
        className="block px-3.5 py-2 rounded-lg text-xs text-slate-300 hover:bg-emerald-500/10 hover:text-emerald-300 transition-colors duration-200"
    >
        {title}
    </a>
);

const NavDrop = ({ label, items, viewAll, testId }) => (
    <div className="relative group">
        <button
            data-testid={testId}
            className="flex items-center gap-1 font-mono-x text-[11px] uppercase tracking-[0.2em] text-slate-400 hover:text-emerald-400 transition-colors duration-300"
        >
            {label}
            <ChevronDown className="w-3 h-3 transition-transform duration-300 group-hover:rotate-180" />
        </button>
        <div className="absolute left-1/2 -translate-x-1/2 top-full pt-3 opacity-0 invisible translate-y-1 group-hover:opacity-100 group-hover:visible group-hover:translate-y-0 transition-all duration-300">
            <div className="w-64 rounded-xl border border-white/10 bg-[#0D111A]/95 backdrop-blur-xl p-2 shadow-2xl shadow-black/50">
                <DropItem href={viewAll.href} title={viewAll.title} testId={`${testId}-view-all`} />
                <div className="my-1.5 border-t border-white/5" />
                {items.map((item) => (
                    <DropItem
                        key={item.id}
                        href="#apply"
                        title={item.title}
                        value={item.value}
                        testId={`${testId}-item-${item.id}`}
                    />
                ))}
            </div>
        </div>
    </div>
);

export const Header = () => (
    <motion.header
        initial={{ y: -80, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
        className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#07090E]/80 border-b border-white/10"
        data-testid="site-header"
    >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
            <a href="#top" className="flex items-center gap-2.5" data-testid="header-logo">
                <span className="w-8 h-8 rounded-md bg-emerald-500 flex items-center justify-center font-display font-black text-[#04110c] text-sm">
                    PA
                </span>
                <span className="font-display font-bold tracking-tight text-sm sm:text-base">
                    PREM <span className="text-emerald-400">ASSOCIATES</span>
                </span>
            </a>
            <nav className="hidden md:flex items-center gap-8" data-testid="header-nav">
                <NavDrop
                    label="Loans"
                    items={LOANS}
                    viewAll={{ href: '#loans', title: 'View All Loans' }}
                    testId="nav-loans-menu"
                />
                <NavDrop
                    label="Insurance"
                    items={INSURANCE}
                    viewAll={{ href: '#insurance', title: 'View All Insurance' }}
                    testId="nav-insurance-menu"
                />
                {NAV.map((item) => (
                    <a
                        key={item.label}
                        href={item.href}
                        data-testid={`nav-link-${item.label.toLowerCase()}`}
                        className="font-mono-x text-[11px] uppercase tracking-[0.2em] text-slate-400 hover:text-emerald-400 transition-colors duration-300"
                    >
                        {item.label}
                    </a>
                ))}
            </nav>
            <a
                href="#apply"
                data-testid="header-apply-button"
                className="group inline-flex items-center gap-1.5 rounded-full bg-emerald-500 px-4 py-2 text-xs font-semibold text-[#04110c] hover:bg-emerald-400 transition-colors duration-300"
            >
                Apply Now
                <ArrowUpRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
        </div>
    </motion.header>
);
